import React, { useCallback, useMemo, useState } from 'react';

import { Box } from '@twilio-paste/core/box';

import { PageComponent } from '../../components/common/PageComponent';
import { SearchCustomerPageActions } from '../../components/SearchCustomers/SearchCustomerPageActions';
import { oimApiContactPanelConfig, SearchOimApiCustomersPanel } from '../../components/SearchCustomers/SearchOimApiCustomersPanel';
import { relationshipsApiCustomerPanelConfig, SearchRelationshipsApiCustomersPanel } from '../../components/SearchCustomers/SearchRelationshipsApiCustomersPanel';
import { SearchRelationshipsApiOimCustomersPanel } from '../../components/SearchCustomers/SearchRelationshipsApiOimCustomersPanel';
import { PanelConfig } from '../../components/SearchCustomers/types';

const relationshipsApiOimCustomerPanelConfig: PanelConfig = {
  title: 'Search Relationships API | OIM Customer Endpoint',
};

const panels = [
  relationshipsApiOimCustomerPanelConfig,
  relationshipsApiCustomerPanelConfig,
  oimApiContactPanelConfig,
];

const changeVisibility = (visible: boolean) => !visible;

export function SearchCustomerPage() {
  const [relationshipsApiOimCustomerPanelVisible, setRelationshipsApiOimCustomerPanelVisible] = useState(true);
  const [relationshipsApiCustomerPanelVisible, setRelationshipsApiCustomerPanelVisible] = useState(true);
  const [oimApiContactPanelVisible, setOimApiContactPanelVisible] = useState(true);

  const visiblePanels = useMemo(()=> [
    relationshipsApiOimCustomerPanelVisible,
    relationshipsApiCustomerPanelVisible,
    oimApiContactPanelVisible,
  ], [relationshipsApiOimCustomerPanelVisible, relationshipsApiCustomerPanelVisible, oimApiContactPanelVisible]);

  const handleToggle = useCallback((idx: number) => {
    switch (idx) {
      case 0:
        setRelationshipsApiOimCustomerPanelVisible(changeVisibility);
        break;
      case 1:
        setRelationshipsApiCustomerPanelVisible(changeVisibility);
        break;
      case 2:
        setOimApiContactPanelVisible(changeVisibility);
        break;
      default:
        break;
    }
  }, []);

  const actions = (
    <SearchCustomerPageActions
      panels={panels}
      visiblePanels={visiblePanels}
      onToggle={handleToggle}
    />
  );

  return (
    <PageComponent
      pageTitle="Search Customers"
      actions={actions}
    >
      <Box padding="space70">
        <Box display="flex" columnGap="space60" alignItems="flex-start" width="100%">
          <Box display={relationshipsApiOimCustomerPanelVisible ? 'block' : 'none'}>
            <SearchRelationshipsApiOimCustomersPanel key={relationshipsApiOimCustomerPanelConfig.title} />
          </Box>
          <Box display={relationshipsApiCustomerPanelVisible ? 'block' : 'none'}>
            <SearchRelationshipsApiCustomersPanel />
          </Box>
          <Box display={oimApiContactPanelVisible ? 'block' : 'none'}>
            <SearchOimApiCustomersPanel />
          </Box>
        </Box>
      </Box>
    </PageComponent>
  );
}
